import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "react-bootstrap";
import PlusIcon from "../assets/images/faq-plus.png";
import MinusIcon from "../assets/images/faq-minus.png";

/*******  db0ee2fb-1843-4012-bea4-0068bf5386c9  *******/ const FaqSection = () => {
  const { t } = useTranslation();
  const faqs = t("skp-faqs", { returnObjects: true });
  const [openIndexes, setOpenIndexes] = useState([0]); // open first by default

  const toggle = (index) => {
    setOpenIndexes(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // close
          : [...prev, index] // open
    );
  };

  return (
    <section className="faq-container jua">
      <Container>
        <h2 className="faq-title section-title">{t("skp-faq-title")}</h2>
        <div className="faq-list ">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button className={`faq-question bg-green ${openIndexes.includes(index) ? "open" : ""}`} onClick={() => toggle(index)}>
                <span>{faq.question}</span>
                <img src={openIndexes.includes(index) ? MinusIcon : PlusIcon} alt={openIndexes.includes(index) ? "Collapse" : "Expand"} className="faq-icon" />
              </button>
              <div className={`faq-answer-wrapper ${openIndexes.includes(index) ? "open" : ""}`}>
                <div className="faq-answer">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FaqSection;
